exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex;\r\n    flex: 1;\r\n    flex-direction: column;\r\n}\r\n\r\n.filter-form {\r\n    margin-top: 20px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.label-col-1 {\r\n    flex: 0 0 80px;\r\n    min-width: 80px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    margin-bottom: 3px;\r\n    line-height: 18px;\r\n}\r\n\r\n.label-col-2 {\r\n    flex: 0 0 120px;\r\n    min-width: 120px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    line-height: 18px;\r\n}\r\n\r\n.label-col-3 {\r\n    flex: 0 0 310px;\r\n    min-width: 310px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    line-height: 18px;\r\n}\r\n\r\n.fixed-box-1 {\r\n    min-width: 100px;\r\n    max-width: 100px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/app/stock/stock-overview/stock-overview.component.css
// module id = 2472
// module chunks = 1